import { useEffect, useRef, useState } from "react";
import { CALENDLY_URL, ensureCalendlyAssets } from "./CalendlyWidget";

export default function CalendlyInline() {
  const containerRef = useRef(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Ensure CSS and JS files for Calendly are loaded
    ensureCalendlyAssets();

    let intervalId;
    const initInline = () => {
      if (window.Calendly && containerRef.current) {
        // Clear container to avoid duplicate widgets
        containerRef.current.innerHTML = "";
        
        window.Calendly.initInlineWidget({
          url: CALENDLY_URL,
          parentElement: containerRef.current,
          prefill: {},
          pageSettings: {
            backgroundColor: "090d16", // Deep slate background to blend with gradients
            hideLandingPageDetails: false,
            hideGdprBanner: true,
            primaryColor: "06b6d4", // Cyan accent color
            textColor: "ffffff", // White text
          },
        });
        
        setLoading(false);
        if (intervalId) clearInterval(intervalId);
      }
    };

    intervalId = setInterval(initInline, 200);

    const timeoutId = setTimeout(() => {
      clearInterval(intervalId);
    }, 10000);

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <section id="schedule" className="px-6 py-20">
      <div className="mx-auto max-w-5xl rounded-[2rem] border border-white/10 bg-white/5 p-6 shadow-2xl shadow-black/20 backdrop-blur md:p-12">
        <p className="mb-4 text-center text-sm font-semibold uppercase tracking-[0.22em] text-cyan-300">
          Book Directly
        </p>
        <h2 className="mb-4 text-center text-3xl font-bold leading-tight text-white md:text-5xl">
          Schedule a Consultation.
        </h2>
        <p className="mx-auto mb-10 max-w-2xl text-center text-slate-200">
          Select a time that works best for you to discuss business exit planning, retirement solutions, or legacy strategies.
        </p>

        <div className="relative w-full rounded-3xl overflow-hidden border border-white/10 bg-slate-950/40 shadow-inner">
          {loading && (
            <div className="absolute inset-0 flex items-center justify-center bg-slate-950/80 z-10 py-60">
              <div className="flex flex-col items-center gap-4">
                <div className="h-10 w-10 animate-spin rounded-full border-4 border-cyan-500 border-t-transparent" />
                <p className="text-sm text-slate-400">Loading Calendar...</p>
              </div>
            </div>
          )}
          {/* Calendly Inline Widget Container */}
          <div
            ref={containerRef}
            className="w-full"
            style={{ height: "1000px", minWidth: "320px" }}
          />
        </div>
      </div>
    </section>
  );
}
